// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import SaoTomePrincipe from '../_raw/flag/icon_flag_sao_tome_principe.png';

export default () => <img src={SaoTomePrincipe} alt="SaoTomePrincipe" />;
